// 文件类型
export var FileType;
(function (FileType) {
    FileType[FileType["DOC"] = 1] = "DOC";
    FileType[FileType["SHEET"] = 2] = "SHEET";
    FileType[FileType["SLIDE"] = 3] = "SLIDE";
    FileType[FileType["FORM"] = 4] = "FORM";
    FileType[FileType["MIND"] = 5] = "MIND";
    FileType[FileType["SMART_CANVAS"] = 6] = "SMART_CANVAS";
    FileType[FileType["SMART_SHEET"] = 7] = "SMART_SHEET";
    FileType[FileType["RESUME"] = 8] = "RESUME";
    FileType[FileType["FLOW_CHART"] = 9] = "FLOW_CHART";
    FileType[FileType["PDF"] = 10] = "PDF";
})(FileType || (FileType = {}));
//# sourceMappingURL=index.js.map